import { render, staticRenderFns } from "./TimeAlmostOutIcon.vue?vue&type=template&id=04996fc9"
import script from "./TimeAlmostOutIcon.vue?vue&type=script&lang=js"
export * from "./TimeAlmostOutIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports